import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import MyNetWorkExploreCard from './MyNetworkExploreCard';
import { Explore } from './myNetworkExplore.types';

interface MyNetworkExploreGridProps {
  items: Explore[];
  reload: () => void;
  updateNotifications: () => void;
  loadMoreSentinel: ReactNode;
}

const MyNetworkExploreGrid = ({
  items,
  reload,
  updateNotifications,
  loadMoreSentinel,
}: MyNetworkExploreGridProps) => (
  <Grid container spacing={2} sx={{ alignItems: 'stretch', pt: 1.5 }}>
    {items.map((connection: Explore) => (
      <Grid key={connection.id} size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>
        <MyNetWorkExploreCard
          connection={connection}
          reload={reload}
          updateNotifications={updateNotifications}
        />
      </Grid>
    ))}
    {loadMoreSentinel}
  </Grid>
);

export default MyNetworkExploreGrid;
